import React from "react";
import Dropzone from "react-dropzone";
import styles from "./ImageUploadArea.module.scss";

function ImageUploadArea({ image, onImageChange, title, desc }) {
  return (
    <Dropzone onDrop={onImageChange} accept="image/*">
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()} className={styles.upload}>
          <div className={styles.imageGroup}>
            <input {...getInputProps()} />
            {image ? (
              <img src={image} className={styles.image} />
            ) : (
              <div className={styles.image} />
            )}
            <div className={styles.iconBackground} />
          </div>
          <div className={styles.desc}>
            <h5 className={styles.title}>{title || "Upload Image"}</h5>
            {desc || (
              <>
                512x512 square aspect ratio,
                <br />
                PNG or JPG format
              </>
            )}
          </div>
        </div>
      )}
    </Dropzone>
  );
}

export default ImageUploadArea;
